import { TranslatableField } from './TranslatableField';
import { HeaderSectionModel } from './page-builder/global-sections/HeaderSectionModel';

export enum ReviewingPeriodStatus {
  Open = 'Open',
  Future = 'Future',
  ClosesSoon = 'ClosingSoon',
  Closed = 'Closed',
}

export enum ReviewerStatus {
  NoAssignments = 'NoAssignments',
  NotStarted = 'NotStarted',
  InProgress = 'InProgress',
  Completed = 'Completed',
}

export interface EventWithAssignedSubmissionsDto {
  id: string;
  name: TranslatableField;
  headerSection: HeaderSectionModel;
  reviewStartDate: string;
  reviewEndDate: string;
  reviewingPeriodStatus: ReviewingPeriodStatus;
  reviewCount: number;
  completedReviewCount: number;
  reviewerStatus: ReviewerStatus;
}
